import { Controller } from '@hotwired/stimulus'

// Toggles the mobile navigation panel in the header.
export default class extends Controller<HTMLElement> {
  static targets = ['panel', 'button']

  declare readonly panelTarget: HTMLElement
  declare readonly buttonTarget: HTMLElement

  toggle(): void {
    const open = this.panelTarget.hidden
    this.panelTarget.hidden = !open
    this.buttonTarget.setAttribute('aria-expanded', String(open))
  }
}
